import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";
//import axios from "axios";
import queryString from "query-string";
import TagSearchList from "../containers/search/TagSearchList";
//import Footer from "../components/Footer";
//import ViewContent from '../containers/main/ViewContent';
import { isMobile, isAndroid, isIOS } from "react-device-detect";
import { Helmet } from "react-helmet-async";

class TagSearch extends Component {
  state = {};
  componentDidMount = () => {
    // if (isMobile) {
    //   alert(
    //     "PC 전용 사이트로 모바일 해상도를 지원하지 않습니다.\n확인을 누르시면 전용 앱 또는 스토어로 이동합니다."
    //   );
    //   this._movieStore();
    // }
  };
  _movieStore = () => {
    if (isIOS) {
      console.log("ios");
      setTimeout(function () {
        window.open("https://itunes.apple.com/kr/app/id687631772", "", "");
      }, 1500);

      window.location.href = "aniplustv://";
    } else if (isAndroid) {
      console.log("andorid");
      setTimeout(function () {
        window.open(
          "https://play.google.com/store/apps/details?id=com.aniplustv.android",
          "",
          ""
        );
      }, 1500);

      window.location.href = "aniplustv://";
    } else {
      setTimeout(function () {
        window.open(
          "https://play.google.com/store/apps/details?id=com.aniplustv.android",
          "",
          ""
        );
      }, 1500);
    }
  };
  render() {
    const { location } = this.props.childProps;
    const query = queryString.parse(location.search);
    ////console.log(query)
    const q = query.q;
    const c = query.c;
    console.log(query);
    return (
      <Fragment>
        {/* {isMobile ? (
          <div
            style={{
              color: "#fff",
              textAlign: "center",
              paddingTop: 100,
            }}
          >
            <p>
              <img src="/img/logo.png" style={{ width: 130 }} />
            </p>
            <p style={{ paddingTop: 20, fontSize: 15 }}>
              모바일에서 지원되지 않는 페이지입니다.
            </p>
            <p style={{ fontSize: 15 }}>전용앱을 이용해주세요.</p>
            <p
              onClick={this._movieStore}
              style={{
                paddingTop: 15,
                color: "#ff5d24",
                fontSize: 15,
                fontWeight: 800,
              }}
            >
              전용앱으로 열기
            </p>
          </div>
        ) : ( */}
        <>
          <Helmet>
            <title>한일 동시방영 작품 목록 - 애니플러스</title>
            <meta name="title" content="한일 동시방영 작품 목록 - 애니플러스" />
            <meta
              name="description"
              content="애니플러스 작품목록 - 스파이 패밀리, 진격의 거인, 주술회전"
            />
            <meta name="robots" content="index,follow" />
            <meta
              name="keywords"
              content="라이브 방송, 애니플러스, 스파이 패밀리, 진격의 거인, 주술회전, 한일동시방영, 애니메이션"
            />

            <meta property="og:type" content="website" />
            <meta
              property="og:title"
              content="한일 동시방영 작품 목록 - 애니플러스"
            />
            <meta
              property="og:description"
              content="애니플러스 작품목록 - 스파이 패밀리, 진격의 거인, 주술회전"
            />
            <meta property="og:url" content="https://www.aniplustv.com/list" />

            <meta name="twitter:card" content="summary" />
            <meta
              name="twitter:title"
              content="한일 동시방영 작품 목록 - 애니플러스"
            />
            <meta
              name="twitter:description"
              content="애니플러스 작품목록 - 스파이 패밀리, 진격의 거인, 주술회전"
            />
            <meta
              name="twitter:domain"
              content="https://www.aniplustv.com/list"
            />

            <link rel="canonical" href="https://www.aniplustv.com/list" />
          </Helmet>
          {/*<ViewContent />*/}
          <TagSearchList
            part={q === "" || q === undefined || q === null ? null : q}
            code={c === "" || c === undefined || c === null ? null : c}
          />
        </>
        {/* )} */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TagSearch));
